import axios from 'axios';
import * as config from "../config";

export const PARSER_STATISTIC_REQUEST= "PARSER_STATISTIC_REQUEST";
export const PARSER_STATISTIC_SUCESS= "PARSER_STATISTIC_SUCESS";
export const PARSER_STATISTIC_ERROR= "PARSER_STATISTIC_ERROR";

export function Get() {
    return(dispatch)=>{
        dispatch({
            type:PARSER_STATISTIC_REQUEST
        });

        axios.get(
            config.apiUrl + "/dashboard/parserstatistic"
        ).then((response)=>{
            dispatch({
                type:PARSER_STATISTIC_SUCESS,
                payload:response.data.content
            })
        }).catch((error)=>{
            dispatch({
                type:PARSER_STATISTIC_ERROR
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/dashboardParserActions.js